module.exports = __webpack_public_path__ + "img/small-3.b6e4672d.webp";